export default __webpack_public_path__ + "static/media/download_icon.c4b4f67b.svg";